import React, { useState, useEffect, useCallback } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { Link } from 'gatsby'
import HamburgerMenu from 'react-hamburger-menu'
import ColorButton from 'src/components/atoms/ColorButton'
import { Logo } from 'src/components/atoms/imageComponents/Logo'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import { vwSize } from 'src/utils/vwCss'
import iconClose from 'src/images/top/icon_close.svg'
import logoImageWhite from 'src/images/top/commmune-logo-white.svg'


const SP_HEADER_HEIGHT = '65px'
//const HEADER_BREAK_POINT = '1237px'
const HEADER_BREAK_POINT = `${BreakPoint.LAPTOP}`
const HEADER_TABLET_BREAK_POINT = '769px'


const Header = ({ top = undefined }) => {
  const [scrollPosition, setScrollPosition] = useState(0)
  const [isOpen, toggle] = useState(false)
  const [isSubMenuOpen, setActive] = useState(false)
  const [windowHeight, setWindowHeight] = useState(0)
  /**
   * ヘッダーの色が変わる位置
   * NOTE: ヘッダー直下のコンテンツによって適切な位置が変わるため、適宜修正を検討する
   */
  const ChangingColorPosition = {
    top: {
      pc: 60,
      sp: 60
    },
    sub: {
      pc: 160,
      sp: 120
    }
  }

  const getColorPosition = top =>
    top ? ChangingColorPosition.top : ChangingColorPosition.sub

  const onScroll = () => {
    setScrollPosition({
      scrollPosition: Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      )
    })
  }

  useEffect(() => {
    document.addEventListener('scroll', onScroll)
    return () => document.removeEventListener('scroll', onScroll)
  })

  const onResize = useCallback(() => {
    setWindowHeight(window.innerHeight)
  }, [])

  useEffect(() => {
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const scrollingPC = scrollPosition.scrollPosition > getColorPosition(top).pc
  const scrollingSP = scrollPosition.scrollPosition > getColorPosition(top).sp

  const classToggle = () => {
    setActive(!isSubMenuOpen)
  }
  const hMenuToggle = () => {
    //isOpen ? document.querySelector('body').classList.add('-fixed') : document.querySelector('body').classList.remove('-fixed')
  }

  return (
    <Container
      isOpen={isOpen}
      isSubMenuOpen={isSubMenuOpen}
      top={top}
      scrollingPC={scrollingPC}
      scrollingSP={scrollingSP}
    >
      <HeaderItems>
        <HeaderMaxWidthWrapper>
          <HeaderItemsInner>
            <LogoWrapper to="/">
              <HeaderLogo />
            </LogoWrapper>
            <LinkWrapper top={top} scrollingPC={scrollingPC}>
            <LinkItem to="/plan/">料金体系</LinkItem>
              <LinkItem to="/case/">導入事例</LinkItem>
              <SubMenuTextWrap 
                className={`g-submenu__wrap ${isSubMenuOpen ? "-opened" : ""}`}
                //onClick={() => classToggle(!isSubMenuOpen)} 
                onMouseEnter={() => classToggle(!isSubMenuOpen)}
                onMouseLeave={() => classToggle(!isSubMenuOpen)}
              >
                <SubMenuText className={"g-submenu__text"}>ソリューション</SubMenuText>
                <SolutionSubMenu className={"g-submenu__list"}>
                  <SubMenuDummy className={"g-submenu__dummy"}></SubMenuDummy>
                  <SubMenuWrap>
                    <SubMenuList className={"g-submenu__list--inner"}>
                      <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/food/">食品業界</LinkItem>
                      <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/school/">教育業界</LinkItem>
                      <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/ec/">EC D2C</LinkItem>
                      <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/retail/">小売業界</LinkItem>
                      <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/maker/">メーカー 製造業</LinkItem>
                      <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune-work.com/">社内/パートナーコミュニケーション</LinkItem>
                      <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/btob/">カスタマーサクセス</LinkItem>
                    </SubMenuList>
                  </SubMenuWrap>
                </SolutionSubMenu>
              </SubMenuTextWrap>
              <LinkItem to="/blog/">ブログ</LinkItem>
              <LinkItem to="/event/">イベント情報</LinkItem>
              <LinkItem to="/news/">ニュース</LinkItem>
              <LinkItem to="/company/">会社概要</LinkItem>
              <LinkItem
                to="https://commmune-careers.studio.site/"
                target="_blank"
              >
                採用情報
              </LinkItem>
            </LinkWrapper>
            <ColorButtonWrapper>
            <ColorButtonHead to="/partner" style={{ textDecoration: 'none' }} target="_blank">
                <PartnerButtonText top={top} scrollingPC={scrollingPC}>パートナー募集</PartnerButtonText>
              </ColorButtonHead>
              <ColorButtonHead to="/whitepapers/" style={{ textDecoration: 'none' }}>
                <ColorButtonText red css={headerDownload}>お役立ち資料</ColorButtonText>
              </ColorButtonHead>
              <ColorButtonHead to="/contact" style={{ textDecoration: 'none' }}>
                <ColorButtonText scrollingPC={scrollingPC} css={headerContact}>
                  お問い合わせ
                </ColorButtonText>
              </ColorButtonHead>
            </ColorButtonWrapper>
          </HeaderItemsInner>
        </HeaderMaxWidthWrapper>
      </HeaderItems>
      {/* sp */}
      <SPHeaderWrapper>
        <HeaderSPItems isOpen={isOpen}>
          <HeaderMaxWidthWrapper>
            <HeaderSPItemsInner>
              <LogoWrapper to="/">
                <HeaderLogo />
              </LogoWrapper>
              {!isOpen && (
                <>
                  <ColorButtonHead
                    to="/whitepapers/"
                    style={{ textDecoration: 'none' }}
                  >
                    <ColorButtonText red>お役立ち資料</ColorButtonText>
                  </ColorButtonHead>
                </>
              )}
              <MenuWrapper>
                <HamburgerMenu
                  css={hamburgerMenu}
                  isOpen={isOpen}
                  menuClicked={() => toggle(!isOpen)}
                  color={isOpen || (top && !scrollingSP) ? `${Styles.color.primary[400]}` : `${Styles.color.primary[400]}` }
                />
                {hMenuToggle()}
                {isOpen && (
                  <CloseBtnWrap>
                    <CloseBtn
                      src={iconClose}
                      alt=""
                    />
                  </CloseBtnWrap>
                )}
              </MenuWrapper>
            </HeaderSPItemsInner>
          </HeaderMaxWidthWrapper>
        </HeaderSPItems>
        <OpendMenu 
          isOpen={isOpen}
          windowHeight={windowHeight}
          className={`g-hmenu ${isOpen ? "-opened" : ""}`}
        >
          <OpendMenuItems>
            <LogoImageWrap>
              <LogoImage
                src={logoImageWhite}
                alt=""
              />
            </LogoImageWrap>
            <OpendMenuItem onClick={() => toggle(!isOpen)} to="/plan/">
              料金体系
            </OpendMenuItem>
            <OpendMenuItem to="/case/">導入事例</OpendMenuItem>
            <SubMenuTextWrap 
              className={`g-submenu__wrap ${isSubMenuOpen ? "-opened" : ""}`}
              onClick={() => classToggle(!isSubMenuOpen)} 
            >
              <SubMenuText className={"g-submenu__text"}>ソリューション</SubMenuText>
              <SolutionSubMenu className={"g-submenu__list"}>
                <SubMenuWrap>
                  <SubMenuList className={"g-submenu__list--inner"}>
                    <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/food/">食品業界</LinkItem>
                    <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/school/">教育業界</LinkItem>
                    <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/ec/">EC D2C</LinkItem>
                    <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/retail/">小売業界</LinkItem>
                    <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune.jp/lp/maker/">メーカー 製造業</LinkItem>
                    <LinkItem onClick={() => classToggle(isSubMenuOpen)} className="g-submenu__link" target="_blank" to="https://commmune-work.com/">社内/パートナーコミュニケーション</LinkItem>
                  </SubMenuList>
                </SubMenuWrap>
              </SolutionSubMenu>
            </SubMenuTextWrap>
            <OpendMenuItem to="/blog/">ブログ</OpendMenuItem>
            <OpendMenuItem onClick={() => toggle(!isOpen)} to="/event/">
              イベント情報
            </OpendMenuItem>
            <OpendMenuItem onClick={() => toggle(!isOpen)} to="/news/">
              ニュース
            </OpendMenuItem>
            <OpendMenuItem to="/company/">会社概要</OpendMenuItem>
            <OpendMenuItem
              to="https://commmune-careers.studio.site/"
              target="_blank"
            >
              採用情報
            </OpendMenuItem>
            <OpendMenuItem onClick={() => toggle(!isOpen)} to="/partner/" target="_blank">
              パートナー募集
            </OpendMenuItem>
            <ButtonMenuWrap css={ButtonMenuWrapWhitePaper}>
              <ButtonWrap className={"g-btn -menu -orange"}>
                <ColorButton
                  text="お役立ち資料"
                  to="/whitepapers/"
                  arrow={false}
                  outer={false}
                />
              </ButtonWrap>
            </ButtonMenuWrap>
            <ButtonMenuWrap>
              <ButtonWrap className={"g-btn -menu -white"}>
                <ColorButton
                  text="お問い合わせ"
                  to="/contact/"
                  arrow={false}
                  outer={false}
                  color="white"
                />
              </ButtonWrap>
            </ButtonMenuWrap>
          </OpendMenuItems>
        </OpendMenu>
      </SPHeaderWrapper>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  z-index: 5000;
  transition: background-color 0.3s, box-shadow 0.3s;
  position: ${({ isOpen, top, scrollingSP }) =>
    top && !scrollingSP && !isOpen ? 'absolute' : 'fixed'};
  top: ${({ isOpen, top, scrollingSP }) =>
    top && !scrollingSP && !isOpen ? '60px' : '0'};
  background-color: ${({ scrollingSP }) => (scrollingSP ? '#ffffff' : 'none')};
  filter: ${({ scrollingSP }) =>
    scrollingSP ? 'drop-shadow(8px 8px 20px rgba(112, 181, 197, 0.15))' : 'none'};
  @media screen and (min-width: ${HEADER_TABLET_BREAK_POINT}) {
    position: ${({ top, scrollingPC }) =>
      top && !scrollingPC ? 'absolute' : 'fixed'};
    top: ${({ isOpen, top, scrollingSP }) =>
      top && !scrollingSP && !isOpen ? '60px' : '0'};
    background-color: ${({ scrollingPC }) =>
      scrollingPC ? Styles.color.grayscale[100] : Styles.color.grayscale[100]};
    filter: ${({ scrollingPC }) =>
      scrollingPC ? 'drop-shadow(8px 8px 20px rgba(112, 181, 197, 0.15))' : 'none'};
  }
`

const HeaderMaxWidthWrapper = styled.div`
  padding: 0 ${vwSize(20, 'pc')}vw;
  box-sizing: border-box;

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: 0 ${vwSize(20, 'sp')}vw;
  }
  @media screen and (max-width: ${BreakPoint.MOBILE}) {
    padding: 0 ${vwSize(15, 'sp')}vw;
  }
`

const LogoWrapper = styled(Link)`
  display: flex;
  align-items: center;
  margin: 0 auto 0 0;
  @media screen and (min-width: ${HEADER_BREAK_POINT}) {
    margin: 0 ${vwSize(40, 'pc')}vw 0 0;
    display: block;
  }

  &:hover {
    opacity: 0.6;
  }
`

const HeaderLogo = styled(Logo)`
  width: ${vwSize(190, 'pc')}vw;
  height: auto;
  @media screen and (max-width: ${HEADER_BREAK_POINT}) {
    width: ${vwSize(70, 'sp')}vw;
  }
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: ${vwSize(150, 'sp')}vw;
  }
`

const HeaderItems = styled.div`
  display: none;
  background: ${({ top, scrollingPC }) =>
    top || scrollingPC ? `${Styles.color.grayscale[100]}` : '${Styles.color.grayscale[100]}'};
  @media screen and (min-width: ${HEADER_BREAK_POINT}) {
    display: block;
    box-sizing: border-box;
    padding: ${vwSize(25, 'pc')}vw 0;
  }
`

const HeaderItemsInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

// このコンポーネントで<LinkItem/>コンポーネントのフォント指定をするためにTypographyを継承している
const LinkWrapper = styled(Typography)`
  flex: 1;
  min-width: 0;
  display: flex;
  gap: ${vwSize(16, 'pc')}vw;
  color: ${Styles.color.primary[400]};
`

const LinkItem = styled(Link)`
  font-family: inherit;
  font-size: ${Styles.pc.fontSize.nav};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  text-align: center;
  color: inherit;
  text-decoration: none;
  letter-spacing: ${Styles.letterSpacing[400]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.nav};
  }
  &:hover {
    color: ${Styles.color.secondary[300]};
  }
`
const SubMenuTextWrap = styled.div`
  position: relative;
`
const SubMenuText = styled.div``
const SolutionSubMenu = styled.div``
const SubMenuDummy = styled.div``
const SubMenuWrap = styled.div``
const SubMenuList = styled.div``

const ColorButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Styles.spacing[6]};
  margin-left: 30px;
`

const ColorButtonHead = styled(Link)`
  margin: 0 ${vwSize(10, 'sp')}vw 0 0;
  @media screen and (min-width: ${HEADER_BREAK_POINT}) {
    line-height: 1;
    margin: 0;
  }
  @media screen and (max-width: 364px) {
    margin: 0 6px 0 0;
  }
  @media screen and (max-width: 320px) {
    display: none;
  }
`

const PartnerButtonText =styled(Typography)`
  display: inline-block;
  wdith: ${vwSize(120, 'pc')}vw;
  font-stretch: normal;
  font-style: normal;
  font-size: ${Styles.pc.fontSize.nav};
  font-weight: bold;
  letter-spacing: ${Styles.letterSpacing[400]};
  color: ${Styles.color.primary[400]};
  border-radius: ${Styles.pc.borderRadius};
  border: solid 2px ${Styles.color.primary[400]};
  text-align: center;
  padding: ${vwSize(9, 'pc')}vw ${vwSize(10, 'pc')}vw;
  box-sizing: border-box;

  &:hover {
    color: ${Styles.color.grayscale[100]};
    background: ${Styles.color.primary[400]};
  }

  //@media screen and (min-width: ${HEADER_BREAK_POINT}) {
  //  width: 110px;
  //  height: 30px;
  //  line-height: 30px;
  //  transform: translateY(0);
  //}
`

const ColorButtonText = styled(Typography)`
  display: inline-block;
  background-color: ${({ red, top, scrollingPC }) =>
    red ? '#ef5e4b' : !top || scrollingPC ? `${Styles.color.primary[400]}` : '#fff'};
  font-size: ${Styles.pc.fontSize.nav};
  font-weight: {$Styles.fontSize.bold};
  padding: ${vwSize(9, 'pc')}vw ${vwSize(15, 'pc')}vw;
  font-style: normal;
  letter-spacing: ${Styles.letterSpacing[400]};
  text-align: center;
  color: ${({ top, scrollingPC }) =>
    !top || scrollingPC ? '#fff' : `${Styles.color.primary[400]}` };
  border-color: ${({ red, top, scrollingPC }) =>
    red ? '#ef5e4b' : !top || scrollingPC ? `${Styles.color.primary[400]}` : '#fff'};
  border-width: 2px;
  border-style: solid;
  border-radius: ${Styles.pc.borderRadius};
  box-sizing: border-box;

  @media screen and (max-width: ${HEADER_BREAK_POINT}) {
    font-size: ${vwSize(6, 'sp')}vw;
    border-radius: ${Styles.pc.borderRadius};
    padding: ${vwSize(4, 'sp')}vw ${vwSize(7, 'sp')}vw;
  }
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.nav};
    border-radius: ${Styles.sp.borderRadius};
    padding: ${vwSize(7, 'sp')}vw ${vwSize(12, 'sp')}vw;
  }

`
const headerDownload = css`
  &:hover {
    background: #ff9f93;
    border-color: #ff9f93;
  }
`
const headerContact = css`
  &:hover {
    background: ${Styles.color.grayscale[100]};
    color: ${Styles.color.primary[400]};
    border: solid 2px ${Styles.color.primary[400]};
  }
`
const SPHeaderWrapper = styled.div`
`
const HeaderSPItems = styled.div`
  background-color: ${({ isOpen }) => (isOpen ? `${Styles.color.primary[400]}` : 'none')};
  @media screen and (min-width: ${HEADER_BREAK_POINT}) {
    display: none;
  }
`

const HeaderSPItemsInner = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: ${SP_HEADER_HEIGHT};
`

const MenuWrapper = styled.div`
  z-index: 10000;
  cursor: pointer;
  display: flex;
  align-items: center;
`
const hamburgerMenu = css`
  width: ${vwSize(42, 'sp')}vw !important;
  //margin-top: 7vw;
  //@media screen and (max-width: ${BreakPoint.MOBILE_L}) {
  //  margin-top: 6vw;
  //}
  //@media screen and (max-width: ${BreakPoint.MOBILE}) {
  //  margin-top: 2vw;
  //}
`
const CloseBtnWrap = styled.div`
  pointer-events: none;
  position: absolute;
  width: ${vwSize(42, 'sp')}vw;
  height: ${vwSize(42, 'sp')}vw;
  z-index: 100;
  top: ${vwSize(5, 'sp')}vw;
  right: ${vwSize(5, 'sp')}vw;

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    top: ${vwSize(15, 'sp')}vw;
    right: ${vwSize(15, 'sp')}vw;
  }
`
const CloseBtn = styled.img`
  pointer-events: none;
`

const OpendMenu = styled.div`
  background-color: ${Styles.color.primary[400]};
  z-index: 5000;
  position: fixed;
  width: 100%;
  min-height: calc(100vh - ${SP_HEADER_HEIGHT});
  min-height: calc(
    ${({ windowHeight }) => `${windowHeight}px`} - ${SP_HEADER_HEIGHT}
  );
  padding: 0 0 env(safe-area-inset-bottom);
  box-sizing: border-box;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  @media screen and (min-width: ${HEADER_BREAK_POINT}) {
    display: none;
  }
`

const OpendMenuItems = styled(Typography)`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  margin: 0;
  box-sizing: border-box;
  min-height: auto;
  padding: ${vwSize(20, 'sp')}vw 0 ${vwSize(27, 'sp')}vw !important;
`
const LogoImageWrap = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  padding: 0 0 ${vwSize(15, 'sp')}vw;
`
const LogoImage = styled.img`
  width: ${vwSize(190, 'sp')}vw;
`
const OpendMenuItem = styled(Link)`
  font-family: inherit;
  font-size: ${Styles.sp.fontSize.tag};
  font-weight: ${Styles.fontWeight.bold};
  font-stretch: normal;
  font-style: normal;
  line-height: ${Styles.lineHeight[350]};
  letter-spacing: ${Styles.pc.letterSpacing};
  color: ${Styles.color.grayscale[100]};
  padding: ${vwSize(12, 'sp')}vw 0;
  text-decoration: none;
`
const ButtonMenuWrap = styled.div`
`
const ButtonMenuWrapWhitePaper = css`
  margin-top: ${vwSize(20, 'sp')}vw;
  margin-bottom: ${vwSize(24, 'sp')}vw;
`
const ButtonWrap = styled.div`
`

const OpendMenuColorButtonLine = styled(Typography)`
  display: flex;
  height: 100px;
  width: 100%;
`

const OpendMenuColorButton = styled(Link)`
  background-color: ${({ white }) => (white ? '#f8f8f8' : '#ef5e4b')};
  font-family: inherit;
  font-size: ${Styles.fontSize[300]};
  font-weight: ${Styles.fontWeight.bold};
  letter-spacing: ${Styles.letterSpacing[400]};
  line-height: 100px;
  text-align: center;
  color: ${({ white }) =>
    white ? Styles.color.primary[400] : Styles.color.grayscale[100]};
  width: 50%;
  text-decoration: none;
`

export default Header
